import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      id: 'dashboard',
      icon: '📊',
      label: 'Dashboard',
      path: '/admin/dashboard'
    },
    {
      id: 'users',
      icon: '👥',
      label: 'Usuarios',
      path: '/admin/users'
    },
    {
      id: 'subscriptions',
      icon: '📝',
      label: 'Suscripciones',
      path: '/admin/subscriptions'
    },
    {
      id: 'payments',
      icon: '💰',
      label: 'Gestor de Pagos',
      path: '/admin/payments'
    },
    {
      id: 'emails',
      icon: '📧',
      label: 'Correos',
      path: '/admin/emails'
    },
    {
      id: 'settings',
      icon: '⚙️',
      label: 'Configuración',
      path: '/admin/settings'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Header */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <span className="logo-icon">🤖</span>
          {!isCollapsed && <span className="logo-text">AI Voice Admin</span>}
        </div>
        <button
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expandir' : 'Contraer'}
        >
          {isCollapsed ? '»' : '«'}
        </button>
      </div>

      {/* Menu Items */}
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <button
            key={item.id}
            className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => handleNavigation(item.path)}
            title={isCollapsed ? item.label : ''}
          >
            <span className="item-icon">{item.icon}</span>
            {!isCollapsed && <span className="item-label">{item.label}</span>}
            {isActive(item.path) && <div className="active-indicator" />}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button
          className="logout-btn"
          onClick={onLogout}
          title={isCollapsed ? 'Cerrar Sesión' : ''}
        >
          <span className="item-icon">🚪</span>
          {!isCollapsed && <span className="item-label">Cerrar Sesión</span>}
        </button>
        {!isCollapsed && (
          <div className="sidebar-credits">
            <p>Desarrollado por</p>
            <p className="developer-name">Rafael Martinez</p>
          </div>
        )}
      </div>

      {/* AI Effects */}
      <div className="sidebar-effects">
        <div className="neural-line line-1"></div>
        <div className="neural-line line-2"></div>
        <div className="neural-line line-3"></div>
        <div className="glow-orb orb-1"></div>
        <div className="glow-orb orb-2"></div>
      </div>
    </div>
  );
};

export default Sidebar;
